import { loadPreferences, myPreferences } from '@/appLogic/view/preferences';
import { TableType } from '@/coreDomainsModule/table';
import { INetworkResult } from '@/coreDomainsModule/networkResult';

/**
 * 非表示のヘッダー配列を取得する
 */
export class GetHiddenTableHeaderPreferenceUseCase {
  /**
   * 非表示のヘッダーの配列を取得する
   * @param tableType - テーブルの種類
   * @returns - {headerList: ヘッダーリスト, allHeaderList: 全てのヘッダーリスト（非表示のものも含める）}
   */
  public async Execute(tableType: TableType): Promise<INetworkResult<string[], Error>> {
    try {
      await loadPreferences();
      if (!myPreferences || !Object.keys(myPreferences).includes(tableType) || !myPreferences[tableType].hideHeaderList) {
        return {
          status: {
            type: 'error',
            error: Error('取得に失敗しました'),
          },
        };
      }

      // 要素の表示/非表示の対応
      const hideHeaderList = myPreferences[tableType].hideHeaderList;

      return {
        status: {
          type: 'success',
          data: hideHeaderList,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
